import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { useEffect, useState } from 'react';

import { ForgotPassword } from '@/components/ForgotPassword/ForgotPassword';
import { ForgotPasswordConfirm } from '@/components/ForgotPassword/ForgotPasswordConfirm';
import PageTitle from '@/components/PageTitle/PageTitle';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getUiForgotPassword, submitForgotPassword } from '@/redux/modules/forgotPassword';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const SendPasswordResetEmailForm = () => {
    const formatMessage = useAppFormatMessage();

    const [workflowStep, setWorkflowStep] = useState<'submit' | 'confirm'>('submit');

    const forgotPasswordUIState = useAppSelector((state) => getUiForgotPassword(state));

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (forgotPasswordUIState.success) {
            setWorkflowStep('confirm');
        }
    }, [dispatch, forgotPasswordUIState.success]);

    const setEmail = (email: string, sendSMS: boolean) => {
        dispatch(submitForgotPassword(email, sendSMS));
    };

    const resendEmail = () => {
        setWorkflowStep('submit');
    };

    const centeredPageTitleClassName = 'w-full text-center';

    return (
        <div className="flex justify-center">
            <div className="top-[215px] min-h-[400px] w-[537px] px-md py-sm smMin:px-2xl">
                {workflowStep === 'submit' ? (
                    <>
                        <PageTitle
                            className={centeredPageTitleClassName}
                            key={1}
                            title={formatMessage(['please_enter_email_below'])}
                        />
                        <BodyPrimary
                            className="mb-md text-center"
                            key={0}
                        >
                            {formatMessage(['send_reset_password'])}
                        </BodyPrimary>
                        <ForgotPassword submitForgotPassword={setEmail} />
                    </>
                ) : (
                    <>
                        <PageTitle
                            className={centeredPageTitleClassName}
                            title={formatMessage(['check_your_email'])}
                        />
                        <ForgotPasswordConfirm resendEmail={resendEmail} />
                    </>
                )}
            </div>
        </div>
    );
};
